import { render, staticRenderFns } from "./AddStepProcedure.vue?vue&type=template&id=6f594733&"
import script from "./AddStepProcedure.vue?vue&type=script&lang=js&"
export * from "./AddStepProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports